import camelCaseKeys from 'utils/camelCaseKeys'
import { getData as apiGetData } from 'api/Api'
import {
  addArray as addDocumentListItemsArray
} from '../redux/documentListItems'
import { AuthError } from '@kanbo/api'

type Payload = {
  documentListItems: {
    documentListItemId: number;
    documentSourceId: number;
    url: string;
  }[]
}

const fetchDocumentListItems = (payload: Payload) => async dispatch => {
  const { documentListItems } = payload

  try {
    const { Items } = await apiGetData('Files', {
      items: documentListItems.map(documentListItem => ({
        sourceId: documentListItem.documentSourceId,
        url: documentListItem.url
      }))
    })

    dispatch(addDocumentListItemsArray(Items.map((Document, index) => ({
      id: documentListItems[index].documentListItemId,
      url: Document.Url,
      name: Document.Name,
      size: Document.Size,
      sourceId: Document.SourceId,
      lastModificationTimestamp: Document.LastModificationTimestamp,
      exists: Document.Exists,
      thumbnailUrl: Document.ThumbnailUrl,
      actions: Document.Actions ? Document.Actions.map(camelCaseKeys) : [],
      position: Document.Position,
      isLoaded: true,
    }))))
  } catch (error) {
    if (error instanceof AuthError) {
      dispatch(addDocumentListItemsArray(documentListItems.map(documentListItem => ({
        id: documentListItem.documentListItemId,
        exists: false,
        isLoaded: true,
      }))))
    } else {
      throw error
    }
  }
}

export default fetchDocumentListItems
